import Constant from '@/common/constant/Constant';
import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import PropTypes from 'prop-types';

export const DialogConfirmSoftDeleteTicket = props => {
    const { isOpen, setIsOpen, detailTicket } = props;

    let messageStatus = I18n.get('MSG-CM-CONFIRM-DELETE-CONTENT-ON-TICKET-LIST');

    if (
        detailTicket?.liveOrArchived === Constant.LIVE_OR_ARCHIVED.ARCHIVED
    ) {
        messageStatus = I18n.get('MSG-CM-CONFIRM-DELETE-CONTENT');
    }

    const onCloseConfirm = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }
        setIsOpen(false);
    };

    const onSubmitSoftDelete = () => {
        props.submitSoftDelete();
        setIsOpen(false);
    };

    return (
        <Dialog
            open={isOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirmPlease">
                    {messageStatus}
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    variant="contained"
                    className="btn-hg32 btn-handle-delete-user-agree btn-handle-delete-user-agree-important"
                    onClick={onSubmitSoftDelete}
                >
                    {I18n.get('CM-BUTTON-OK')}
                </Button>
                <Button
                    variant="contained"
                    className="btn-light btn-hg32"
                    onClick={(event, reason) => onCloseConfirm(event, reason)}
                >
                    {I18n.get('CM-BUTTON-CANCEL')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

DialogConfirmSoftDeleteTicket.propTypes = {
    isOpen: PropTypes.any,
    setIsOpen: PropTypes.any,
    detailTicket: PropTypes.any,
};